import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles, Chip } from '@material-ui/core'
import pick from 'lodash.pick'
import isEqual from 'lodash.isequal'
import isempty from 'lodash.isempty'
import keyBy from 'lodash.keyby'
import { saveSearch } from 'services/api'
import { showFlashMessageOnUnexpectedError, showFlashMessage } from 'actions'
import { isUserLogged, trackEvent } from 'utils'
import { MESSAGE } from '../../../constants'

const styles = theme => ({
  chip: {
    backgroundColor: 'transparent',
    border: '1px solid',
    marginLeft: '18px',
    color: '#00bcb5',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      margin: '10px 0 0 0',
      lineHeight: '30px',
    },
  },
})

const relevantFilterKeys = [
  'propertyTypesSelected',
  'priceMinimum',
  'priceMaximum',
  'numberOfBedrooms',
  'numberOfBathrooms',
  'homeTypesSelected',
  'areaMaximum',
  'areaMinimum',
]

class SaveSearch extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isSaved: false,
    }
  }

  static propTypes = {
    classes: PropTypes.object.isRequired,
    searchedLocation: PropTypes.string.isRequired,
    filters: PropTypes.object.isRequired,
    bounds: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    showFlashMessageOnUnexpectedError: PropTypes.func.isRequired,
    showFlashMessage: PropTypes.func.isRequired,
  }

  componentDidUpdate(prevProps) {
    if (
      !isEqual(prevProps.searchedLocation, this.props.searchedLocation) ||
      !isEqual(prevProps.filters, this.props.filters) ||
      !isEqual(prevProps.bounds, this.props.bounds)
    ) {
      this.setState({
        isSaved: false,
      })
    }
    if (this.state.isSaved && !isUserLogged(this.props.user)) {
      this.setState({
        isSaved: false,
      })
    }
  }

  doSaveSearch = async ({ token, geoRect, filters, location }) => {
    try {
      const response = await saveSearch(token, geoRect, filters, location)

      if (isempty(response.errors)) {
        trackEvent({ category: 'Save search', action: 'For location - ' + location })
        this.setState({
          isSaved: true,
        })
      }
    } catch (error) {
      this.props.showFlashMessageOnUnexpectedError(error)
    }
  }

  handleClick = () => {
    const { searchedLocation, filters, bounds, user, showFlashMessage, defaultFiltersValues } = this.props

    if (!isUserLogged(user)) {
      showFlashMessage(false, MESSAGE.LOGIN_ERROR_MESSAGE)
      return
    }

    let appliedFilters = {
      baths: filters.numberOfBathrooms,
      beds: filters.numberOfBedrooms,
      homeTypes: filters.homeTypesSelected,
      types: filters.propertyTypesSelected,
    }

    // FIXME: here we are determing if ranges were actually entered by the user or just using  default values,
    // this shouldn't work this way, filters object should only contain values specified by the user or undenfinded/null/0
    if (filters.priceMinimum !== defaultFiltersValues.price.value[0] || filters.priceMaximum !== defaultFiltersValues.price.value[1]) {
      appliedFilters = {
        ...appliedFilters,
        ...{
          priceMin: filters.priceMinimum,
          priceMax: filters.priceMaximum,
        },
      }
    }

    if (filters.areaMinimum !== defaultFiltersValues.area.value[0] || filters.areaMaximum !== defaultFiltersValues.area.value[1]) {
      appliedFilters = {
        ...appliedFilters,
        ...{
          areaMin: filters.areaMinimum,
          areaMax: filters.areaMaximum,
        },
      }
    }

    const search = {
      token: user.token,
      filters: appliedFilters,
      geoRect: bounds,
      location: searchedLocation,
    }

    this.doSaveSearch(search)
  }

  render() {
    const { classes } = this.props

    const label = this.state.isSaved ? 'Your search has been saved' : 'SAVE SEARCH'

    const propss = !this.state.isSaved ? { onClick: this.handleClick } : {}

    return <Chip {...propss} label={label} className={classes.chip} />
  }
}

function mapStateToProps(state) {
  return {
    searchedLocation: state.properties.queryAddress,
    filters: state.filters && pick(state.filters, relevantFilterKeys),
    defaultFiltersValues: keyBy(state.filters.filterTypes, 'name'),
    bounds: state.properties.viewPort.toJSON(),
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ showFlashMessageOnUnexpectedError, showFlashMessage: showFlashMessage }, dispatch)
}

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SaveSearch)
)



// WEBPACK FOOTER //
// ./src/features/savedSearches/components/SaveSearch.js